import classNames from "classnames";

import { AgentThreadStatus } from "@/shared/domain/agentThread";

import styles from "./ThreadStatusBadge.module.css";

interface ThreadStatusBadgeProps {
  status: AgentThreadStatus;
}

const STATUS_DISPLAY: Record<
  AgentThreadStatus,
  { label: string; className: string }
> = {
  [AgentThreadStatus.NOT_STARTED]: {
    label: "Not started",
    className: styles.notStarted,
  },
  [AgentThreadStatus.USER_TURN]: {
    label: "User turn",
    className: styles.userTurn,
  },
  [AgentThreadStatus.ROBOTO_TURN]: {
    label: "Working",
    className: styles.robotoTurn,
  },
  [AgentThreadStatus.CLIENT_TOOL_TURN]: {
    label: "Client tools",
    className: styles.clientToolTurn,
  },
  [AgentThreadStatus.GOALS_FAILED]: {
    label: "Goals failed",
    className: styles.goalsFailed,
  },
};

export function ThreadStatusBadge({ status }: ThreadStatusBadgeProps) {
  const display = STATUS_DISPLAY[status];
  return (
    <span className={classNames(styles.badge, display.className)}>
      {display.label}
    </span>
  );
}
